/**
 * Audio API Configuration
 * 
 * Configuration for the Native Voice Capture API endpoints
 * across different environments (development, staging, production).
 */

export interface AudioAPIConfig {
  /** Base URL for the audio upload API */
  uploadApiUrl: string;
  /** Base URL for the transcription API (if separate) */
  transcriptionApiUrl?: string;
  /** Environment name */
  environment: 'development' | 'staging' | 'production';
}

/**
 * Get the API configuration based on the current environment
 * 
 * Uses the BFF (Backend For Frontend) proxy for audio uploads.
 * The BFF handles authentication and routes to the correct backend service.
 * 
 * Note: The audio upload client adds '/audio/upload/...' to this base URL,
 * so we return '/api' which becomes '/api/audio/upload/...'
 */
export function getAudioAPIConfig(): AudioAPIConfig {
  // Use BFF proxy at /api
  // The audio-upload-client will add '/audio/upload/...' to make '/api/audio/upload/...'
  // The BFF will route this to the correct backend service
  return {
    uploadApiUrl: '/api',
    environment: import.meta.env?.MODE === 'production' ? 'production' : 'development',
  };
}

/**
 * Production API endpoints
 * 
 * These are the deployed Cloud Run services for the Native Voice Capture feature
 */
export const PRODUCTION_API_ENDPOINTS = {
  uploadApi: 'https://audio-upload-api-689311789716.us-central1.run.app/api/v1',
  transcriptionApi: 'https://audio-transcription-689311789716.us-central1.run.app',
} as const;

/**
 * Development API endpoints (localhost)
 */
export const DEVELOPMENT_API_ENDPOINTS = {
  uploadApi: 'http://localhost:8080/api/v1',
  transcriptionApi: 'http://localhost:8081',
} as const;

